<template>
  <div>
    <div class="row row-equal">
      <div class="flex md12">
        <va-card title="Gestion des factures">
          <div class="flex md12">
            <div class="row row-inside">
              <div class="flex md3">
                <va-input
                  :value="searchTerm"
                  placeholder="Nom du partenaire, numéro, numéro de devis..."
                  removable
                  @input="searchText"
                >
                  <va-icon name="fa fa-search" slot="prepend" />
                </va-input>
              </div>
              <div class="flex md2">
                <va-button
                  class="fullwidth"
                  :color="filterByAttribution ? 'success' : 'info'"
                  @click="filterByAttribution = !filterByAttribution"
                  >Mes factures</va-button
                >
              </div>
              <div class="flex md2">
                <va-button
                  class="fullwidth"
                  :color="filterByPaidStatus ? 'success' : 'info'"
                  @click="filterByPaidStatus = !filterByPaidStatus"
                  >Factures impayées</va-button
                >
              </div>
              <div class="flex md2">
                <va-date-picker
                  label="Date de début"
                  :config="{ dateFormat: 'd-m-Y' }"
                  v-model="dateFilterStart"
                />
              </div>
              <div class="flex md2">
                <va-date-picker
                  label="Date de fin"
                  :config="{ dateFormat: 'd-m-Y' }"
                  v-model="dateFilterEnd"
                />
              </div>
            </div>
          </div>
          <div class="row row-inside separator">
            <div class="flex md1 col-title">N° facture</div>
            <div class="flex md2 col-title">Nom du partenaire</div>
            <div class="flex md1 col-title">Date de facturation</div>
            <div class="flex md1 col-title">Montant</div>
            <div class="flex md1 col-title">Paiement</div>
            <div class="flex md1 col-title">Edition</div>

            <div class="flex md1 col-title">Devis</div>
            <div class="flex md1 col-title">Numéro concernés</div>
            <div class="flex md1 col-title">Relances</div>

            <div class="flex md2 col-title">Attribué</div>
          </div>
          <div class="row row-inside">
            <div class="flex md12" v-for="(element, index) in listeFactures">
              <factures-liste-line
                :facture="element"
                v-on:reset="resetElement(element)"
              />
            </div>
          </div>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep, sortedUniq, sortBy, find, debounce, deburr } from "lodash";
import moment from "moment";
import FacturesListeLine from "./facturesListeLine.vue";

export default {
  name: "facture-list",
  components: { FacturesListeLine },

  data() {
    return {
      //export within context
      moment: moment,
      listeFactureFull: [],
      searchTerm: null,
      filterByAttribution: false,
      dateFilterStart: null,
      dateFilterEnd: null,
      filterByPaidStatus: false,
    };
  },
  created() {
    this.getListeFactures();
  },
  computed: {
    listeFactures() {
      let filteredData = sortBy(this.listeFactureFull, ["nom_partenaire"]);
      if (
        !this.searchTerm &&
        !this.filterByAttribution &&
        !this.filterByPaidStatus &&
        !this.dateFilterStart &&
        !this.dateFilterEnd
      ) {
        return filteredData;
      }
      return filteredData.filter((item) => {
        let boolcond = true;

        if (this.filterByAttribution) {
          boolcond =
            item.idutilisateur_attribution ===
            this.$store.getters.user.idutilisateurs;
        }

        if (this.filterByPaidStatus) {
          boolcond = boolcond && !item.date_paiement;
        }

        if (this.searchTerm && this.searchTerm.length >= 1) {
          let searchTermClean = deburr(this.searchTerm).toLowerCase();
          let factnum =
            moment(item.date_facturation, "YYYY-MM-DD").format("YYYY") +
            "/" +
            moment(item.date_facturation, "YYYY-MM-DD").format("MM") +
            "-" +
            item.idfacture_publication;

          boolcond =
            (boolcond &&
              (deburr(item.nom_partenaire)
                .toLowerCase()
                .includes(searchTermClean) ||
                deburr(item.nb_devis)
                  .toLowerCase()
                  .includes(searchTermClean))) ||
            deburr(item.numero).toLowerCase().includes(searchTermClean) ||
            deburr(factnum).toLowerCase().includes(searchTermClean);
        }

        if (this.dateFilterStart) {
          console.log("test");
          boolcond =
            boolcond &&
            moment(item.date_facturation, "YYYY-MM-DD").isSameOrAfter(
              moment(this.dateFilterStart, "DD-MM-YYYY")
            );
        }

        if (this.dateFilterEnd) {
          boolcond =
            boolcond &&
            moment(item.date_facturation, "YYYY-MM-DD").isSameOrBefore(
              moment(this.dateFilterEnd, "DD-MM-YYYY")
            );
        }

        return boolcond;
      });
    },
  },
  methods: {
    searchText: debounce(function (searchTerm) {
      this.searchTerm = searchTerm;
    }, 400),
    resetElement(element) {
      this.getListeFactures();
    },
    async getListeFactures() {
      try {
        let res = await axios.get("/api/publications/liste-factures");
        this.listeFactureFull = [];
        this.listeFactureFull = res.data;
      } catch (error) {
        this.launchEpicmaxToast(
          "Erreur lors du chargement de la liste des devis"
        );
        console.log(error);
      }
    },
  },
};
</script>

<style>
</style>
